import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='codigo'>
          {({ field }) => (
            <Form.InputText {...field} id='input-codigo' isInvalid={iError && iTouched} disabled={fIsSubmitting} />
          )}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
